import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-employee-view',
  templateUrl: './user-employee-view.component.html',
  styleUrls: ['./user-employee-view.component.sass']
})
export class UserEmployeeViewComponent implements OnInit {
  userId = null;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = this.activatedRoute.snapshot.params.id;

  }
  viewEmployee() {
    this.router.navigate(['users/' + this.userId + '/employee/view']);
  }
}
